import { Draft } from '@reduxjs/toolkit';

import { IAuthData } from '../../index';

function forgotPasswordFailure(draft: Draft<IAuthData>) {
  draft.forgotPassword.config.isLoading = false;
}

export default forgotPasswordFailure;
